/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InvoiceAudit
 */
export interface InvoiceAudit {
  /**
   *
   * @type {string}
   * @memberof InvoiceAudit
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAudit
   */
  proNumber?: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceAudit
   */
  billOfLadingNumber?: string;
  /**
   * Pickup "City, State".
   * @type {string}
   * @memberof InvoiceAudit
   */
  pickup: string;
  /**
   * Delivery "City, State".
   * @type {string}
   * @memberof InvoiceAudit
   */
  delivery: string;
  /**
   * Business name at the pickup location.
   * @type {string}
   * @memberof InvoiceAudit
   */
  pickupBusinessName?: string;
  /**
   * Business name at the delivery location.
   * @type {string}
   * @memberof InvoiceAudit
   */
  deliveryBusinessName?: string;
  /**
   * Pre-formatted scheduled pickup date.
   * @type {string}
   * @memberof InvoiceAudit
   */
  pickupDate?: string;
  /**
   * What FreightSimple agreed to pay at booking (CAD, without tax).
   * @type {number}
   * @memberof InvoiceAudit
   */
  quotedCad?: number;
  /**
   * The carrier's invoices minus credit notes to date (CAD, without
   * tax). Omitted until at least one invoice has arrived.
   *
   * @type {number}
   * @memberof InvoiceAudit
   */
  invoicedCad?: number;
  /**
   * Carrier-friendly labels for the problems still being worked
   * through, e.g. "Liftgate at Delivery". Resolved problems are
   * excluded.
   *
   * @type {Array<string>}
   * @memberof InvoiceAudit
   */
  problems: Array<string>;
  /**
   * True when FreightSimple is waiting on the carrier's reply in the
   * audit conversation.
   *
   * @type {boolean}
   * @memberof InvoiceAudit
   */
  waitingOnCarrier: boolean;
  /**
   * True when the audit is sitting with the customer rather than with
   * us or the carrier. Mutually exclusive with waitingOnCarrier, which
   * wins if somehow both turns are set. Both false means it is with
   * FreightSimple.
   *
   * @type {boolean}
   * @memberof InvoiceAudit
   */
  waitingOnCustomer?: boolean;
  /**
   * ISO-8601 date the audit was first opened (the frontend renders it
   * as a relative-age badge).
   *
   * @type {string}
   * @memberof InvoiceAudit
   */
  openedAt?: string;
}

/**
 * Check if a given object implements the InvoiceAudit interface.
 */
export function instanceOfInvoiceAudit(value: object): value is InvoiceAudit {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("pickup" in value) || value["pickup"] === undefined) return false;
  if (!("delivery" in value) || value["delivery"] === undefined) return false;
  if (!("problems" in value) || value["problems"] === undefined) return false;
  if (!("waitingOnCarrier" in value) || value["waitingOnCarrier"] === undefined)
    return false;
  return true;
}

export function InvoiceAuditFromJSON(json: any): InvoiceAudit {
  return InvoiceAuditFromJSONTyped(json, false);
}

export function InvoiceAuditFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceAudit {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    pickup: json["pickup"],
    delivery: json["delivery"],
    pickupBusinessName:
      json["pickupBusinessName"] == null
        ? undefined
        : json["pickupBusinessName"],
    deliveryBusinessName:
      json["deliveryBusinessName"] == null
        ? undefined
        : json["deliveryBusinessName"],
    pickupDate: json["pickupDate"] == null ? undefined : json["pickupDate"],
    quotedCad: json["quotedCad"] == null ? undefined : json["quotedCad"],
    invoicedCad: json["invoicedCad"] == null ? undefined : json["invoicedCad"],
    problems: json["problems"],
    waitingOnCarrier: json["waitingOnCarrier"],
    waitingOnCustomer:
      json["waitingOnCustomer"] == null ? undefined : json["waitingOnCustomer"],
    openedAt: json["openedAt"] == null ? undefined : json["openedAt"],
  };
}

export function InvoiceAuditToJSON(json: any): InvoiceAudit {
  return InvoiceAuditToJSONTyped(json, false);
}

export function InvoiceAuditToJSONTyped(
  value?: InvoiceAudit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    proNumber: value["proNumber"],
    billOfLadingNumber: value["billOfLadingNumber"],
    pickup: value["pickup"],
    delivery: value["delivery"],
    pickupBusinessName: value["pickupBusinessName"],
    deliveryBusinessName: value["deliveryBusinessName"],
    pickupDate: value["pickupDate"],
    quotedCad: value["quotedCad"],
    invoicedCad: value["invoicedCad"],
    problems: value["problems"],
    waitingOnCarrier: value["waitingOnCarrier"],
    waitingOnCustomer: value["waitingOnCustomer"],
    openedAt: value["openedAt"],
  };
}
